import { UserGroupsEnum } from '../../enums/user-groups.enum'
import { IConfig } from '../../models/login-response.model'

export function getMenuData(config?: IConfig): any[] {
  return [
    {
      title: 'Dashboard',
      key: 'dashboard',
      svg: './assets/images/icons/menu/dashboard_white_icon_m.svg',
      ico_class: '',
      url: '/spas/dashboard',
      children: [
        {
          title: 'Dashboard Tiles',
          url: '/spas/dashboard/dashboard-tiles',
          roles: [
            UserGroupsEnum.SPAS_Admin,
            UserGroupsEnum.SPAS_Operator,
            UserGroupsEnum.SPAS_CBMLead,
            UserGroupsEnum.SPAS_RCALead,
            UserGroupsEnum.SPAS_Guest,
          ],
        },
      ],
    },
    {
      title: 'Proof Tests',
      key: 'proof_test',
      svg: './assets/images/icons/menu/proof_tests_white_icon_m.svg',
      url: '/spas/proof-test',
      ico_class: '',
      children: [
        {
          title: 'Proof Test Overview',
          url: '/spas/proof-test/overview',
          roles: [
            UserGroupsEnum.SPAS_Admin,
            UserGroupsEnum.SPAS_Operator,
            UserGroupsEnum.SPAS_CBMLead,
            UserGroupsEnum.SPAS_RCALead,
            UserGroupsEnum.SPAS_Guest,
          ],
        },
        {
          title: 'Proof Test Approval',
          url: '/spas/proof-test/approval',
          roles: [
            UserGroupsEnum.SPAS_Admin,
            UserGroupsEnum.SPAS_Operator,
            UserGroupsEnum.SPAS_CBMLead,
            UserGroupsEnum.SPAS_RCALead,
            UserGroupsEnum.SPAS_Guest,
          ],
          modules: [
            { name: 'CMMS', display: true },
            { name: 'CMMS_PTA', display: true },
          ],
        },
        {
          title: 'Program Verification',
          url: '/spas/proof-test/program-verification',
          roles: [
            UserGroupsEnum.SPAS_Admin,
            UserGroupsEnum.SPAS_Operator,
            UserGroupsEnum.SPAS_CBMLead,
            UserGroupsEnum.SPAS_RCALead,
            UserGroupsEnum.SPAS_Guest,
          ],
          modules: [{ name: 'CMMS', display: true }],
        },
        {
          title: 'Proof Test Look-Ahead',
          url: '/spas/proof-test/wks-look-ahead',
          roles: [
            UserGroupsEnum.SPAS_Admin,
            UserGroupsEnum.SPAS_Operator,
            UserGroupsEnum.SPAS_CBMLead,
            UserGroupsEnum.SPAS_RCALead,
            UserGroupsEnum.SPAS_Guest,
          ],
          modules: [{ name: 'CMMS', display: true }],
        },
      ],
    },
    {
      title: 'Final Elements',
      key: 'final_element_insight',
      svg: './assets/images/icons/menu/final_elements_white_icon_m.svg',
      ico_class: '',
      url: '/spas/final-element-insight',
      children: [
        {
          title: 'Final Element Overview',
          url: '/spas/final-element-insight/final-element-overview',
          roles: [
            UserGroupsEnum.SPAS_Admin,
            UserGroupsEnum.SPAS_Operator,
            UserGroupsEnum.SPAS_CBMLead,
            UserGroupsEnum.SPAS_RCALead,
            UserGroupsEnum.SPAS_Guest,
          ],
        },
        {
          title: 'Final Element Activations',
          url: '/spas/final-element-insight/final-element-activations',
          roles: [
            UserGroupsEnum.SPAS_Admin,
            UserGroupsEnum.SPAS_Operator,
            UserGroupsEnum.SPAS_CBMLead,
            UserGroupsEnum.SPAS_RCALead,
            UserGroupsEnum.SPAS_Guest,
          ],
        },
        {
          title: 'TravelTime Monitoring',
          url: '/spas/final-element-insight/travel-time-monitoring',
          roles: [
            UserGroupsEnum.SPAS_Admin,
            UserGroupsEnum.SPAS_Operator,
            UserGroupsEnum.SPAS_CBMLead,
            UserGroupsEnum.SPAS_RCALead,
            UserGroupsEnum.SPAS_Guest,
          ],
        },
        {
          title: 'SafeState Limit Switch',
          url: '/spas/final-element-insight/safe-state-limit-switch',
          roles: [
            UserGroupsEnum.SPAS_Admin,
            UserGroupsEnum.SPAS_CBMLead,
            UserGroupsEnum.SPAS_RCALead,
          ],
        },
        {
          title: 'Equipment Non-Op.',
          url: '/spas/final-element-insight/non-operational-equipment',
          roles: [
            UserGroupsEnum.SPAS_Admin,
            UserGroupsEnum.SPAS_Operator,
            UserGroupsEnum.SPAS_CBMLead,
            UserGroupsEnum.SPAS_RCALead,
            UserGroupsEnum.SPAS_Guest,
          ],
          modules: [{ name: 'BLE_NOE', display: true }],
        },
      ],
    },
    {
      title: 'Initiators',
      key: 'insight_initiator',
      svg: './assets/images/icons/menu/initiators_white_icon_m.svg',
      ico_class: '',
      url: '/spas/initiators',
      children: [
        {
          title: 'Initiator Faults',
          url: '/spas/initiators/initiator-faults',
          roles: [
            UserGroupsEnum.SPAS_Admin,
            UserGroupsEnum.SPAS_Operator,
            UserGroupsEnum.SPAS_CBMLead,
            UserGroupsEnum.SPAS_RCALead,
            UserGroupsEnum.SPAS_Guest,
          ],
        },
        {
          title: 'Process Demands',
          url: '/spas/initiators/process-demands',
          roles: [
            UserGroupsEnum.SPAS_Admin,
            UserGroupsEnum.SPAS_Operator,
            UserGroupsEnum.SPAS_CBMLead,
            UserGroupsEnum.SPAS_RCALead,
            UserGroupsEnum.SPAS_Guest,
          ],
        },
        {
          title: 'F&G Demands',
          url: '/spas/initiators/fg-demands',
          roles: [
            UserGroupsEnum.SPAS_Admin,
            UserGroupsEnum.SPAS_Operator,
            UserGroupsEnum.SPAS_CBMLead,
            UserGroupsEnum.SPAS_RCALead,
            UserGroupsEnum.SPAS_Guest,
          ],
        },
        {
          title: 'Demand Analysis',
          url: '/spas/initiators/demand-analysis',
          roles: [
            UserGroupsEnum.SPAS_Admin,
            UserGroupsEnum.SPAS_Operator,
            UserGroupsEnum.SPAS_CBMLead,
            UserGroupsEnum.SPAS_RCALead,
            UserGroupsEnum.SPAS_Guest,
          ],
        },
      ],
    },
    {
      title: 'Fault Analysis',
      key: 'fault_analysis',
      svg: './assets/images/icons/menu/fault_analysis_white_icon_m.svg',
      ico_class: '',
      url: '/spas/fault-analysis',
      children: [
        {
          title: 'Final Element Fault Statistics',
          url: '/spas/fault-analysis/final-element-fault-statistics',
          roles: [
            UserGroupsEnum.SPAS_Admin,
            UserGroupsEnum.SPAS_Operator,
            UserGroupsEnum.SPAS_CBMLead,
            UserGroupsEnum.SPAS_RCALead,
            UserGroupsEnum.SPAS_Guest,
          ],
        },
        {
          title: 'Initiator Fault Statistics',
          url: '/spas/fault-analysis/initiator-fault-statistics',
          roles: [
            UserGroupsEnum.SPAS_Admin,
            UserGroupsEnum.SPAS_Operator,
            UserGroupsEnum.SPAS_CBMLead,
            UserGroupsEnum.SPAS_RCALead,
            UserGroupsEnum.SPAS_Guest,
          ],
          modules: [{ name: 'CMMS', display: true }],
        },
        {
          title: 'Root Cause Analysis',
          url: '/spas/fault-analysis/root-cause-analysis',
          roles: [
            UserGroupsEnum.SPAS_Admin,
            UserGroupsEnum.SPAS_Operator,
            UserGroupsEnum.SPAS_CBMLead,
            UserGroupsEnum.SPAS_RCALead,
            UserGroupsEnum.SPAS_Guest,
          ],
          modules: [{ name: 'RCAF', display: true }],
        },
        {
          title: 'FE Current Rating',
          url: '/spas/fault-analysis/current-rating',
          roles: [
            UserGroupsEnum.SPAS_Admin,
            UserGroupsEnum.SPAS_Operator,
            UserGroupsEnum.SPAS_CBMLead,
            UserGroupsEnum.SPAS_RCALead,
            UserGroupsEnum.SPAS_Guest,
          ],
          modules: [{ name: 'RCAF', display: true }],
        },
      ],
    },
    {
      title: 'Overrides',
      key: 'overrides',
      svg: './assets/images/icons/menu/overrides_white_icon_m.svg',
      ico_class: '',
      url: '/spas/overrides',
      children: [
        {
          title: 'Override Tracker',
          url: '/spas/overrides/override-tracker',
          roles: [
            UserGroupsEnum.SPAS_Admin,
            UserGroupsEnum.SPAS_Operator,
            UserGroupsEnum.SPAS_CBMLead,
            UserGroupsEnum.SPAS_RCALead,
            UserGroupsEnum.SPAS_Guest,
          ],
        },
        {
          title: 'Override Analysis',
          url: '/spas/overrides/override-analysis',
          roles: [
            UserGroupsEnum.SPAS_Admin,
            UserGroupsEnum.SPAS_Operator,
            UserGroupsEnum.SPAS_CBMLead,
            UserGroupsEnum.SPAS_RCALead,
            UserGroupsEnum.SPAS_Guest,
          ],
        },
      ],
    },
    {
      title: 'Shutdowns',
      key: 'shutdowns',
      svg: './assets/images/icons/menu/shutdowns_white_icon_m.svg',
      ico_class: '',
      url: '/spas/shutdowns',
      children: [
        {
          title: 'Shutdown Overview Light',
          url: '/spas/shutdowns/overview-light',
          roles: [
            UserGroupsEnum.SPAS_Admin,
            UserGroupsEnum.SPAS_Operator,
            UserGroupsEnum.SPAS_CBMLead,
            UserGroupsEnum.SPAS_RCALead,
            UserGroupsEnum.SPAS_Guest,
          ],
          modules: [{ name: 'SHD_LIGHT', display: true }],
        },
        {
          title: 'Shutdown Insight',
          url: '/spas/shutdowns/insight',
          roles: [
            UserGroupsEnum.SPAS_Admin,
            UserGroupsEnum.SPAS_Operator,
            UserGroupsEnum.SPAS_CBMLead,
            UserGroupsEnum.SPAS_RCALead,
            UserGroupsEnum.SPAS_Guest,
          ],
          modules: [{ name: 'SHD', display: true }],
        },
      ],
    },
    {
      title: 'SIF Manual',
      key: 'sif_manual',
      svg: './assets/images/icons/menu/sif_manual_white_icon_m.svg',
      ico_class: '',
      url: '/spas/sif-manual',
      children: [
        {
          title: 'Overview',
          url: '/spas/sif-manual/overview',
          roles: [
            UserGroupsEnum.SPAS_Admin,
            UserGroupsEnum.SPAS_Operator,
            UserGroupsEnum.SPAS_CBMLead,
            UserGroupsEnum.SPAS_RCALead,
            UserGroupsEnum.SPAS_Guest,
          ],
        },
        {
          title: 'Logic Solver Response Time',
          url: '/spas/sif-manual/logic-solver-response-time',
          roles: [
            UserGroupsEnum.SPAS_Admin,
            UserGroupsEnum.SPAS_Operator,
            UserGroupsEnum.SPAS_CBMLead,
            UserGroupsEnum.SPAS_RCALead,
            UserGroupsEnum.SPAS_Guest,
          ],
        },
        {
          title: 'Status Tracker',
          url: '/spas/sif-manual/status-tracker',
          roles: [
            UserGroupsEnum.SPAS_Admin,
            UserGroupsEnum.SPAS_Operator,
            UserGroupsEnum.SPAS_CBMLead,
            UserGroupsEnum.SPAS_RCALead,
            UserGroupsEnum.SPAS_Guest,
          ],
        },
      ],
    },
    {
      title: 'Admin',
      key: 'admin',
      svg: './assets/images/icons/menu/admin_white_icon_m.svg',
      ico_class: '',
      url: '/spas/admin',
      children: [
        {
          title: 'Event Viewer',
          url: '/spas/admin/event/viewer',
          roles: [
            UserGroupsEnum.SPAS_Admin,
            UserGroupsEnum.SPAS_CBMLead,
            UserGroupsEnum.SPAS_RCALead,
            UserGroupsEnum.SPAS_Configurator,
          ],
          children: [
            {
              title: 'Spas Event',
              url: '/spas/admin/event/viewer/base',
              roles: [
                UserGroupsEnum.SPAS_Admin,
                UserGroupsEnum.SPAS_CBMLead
              ],
            },
            {
              title: 'Raw Event Viewer',
              url: '/spas/admin/event/viewer/raw',
              roles: [
                UserGroupsEnum.SPAS_Admin,
                UserGroupsEnum.SPAS_CBMLead,
                UserGroupsEnum.SPAS_RCALead,
                UserGroupsEnum.SPAS_Configurator,
              ],
            },
          ],
        },
        {
          title: 'Initiator Analyzer',
          url: '/spas/admin/initiator-analyzer',
          roles: [],
        },
        {
          title: 'Shutdown Analyzer',
          url: '/spas/admin/shutdown-analyzer',
          roles: [UserGroupsEnum.SPAS_Admin],
        },
        {
          title: 'Final Element Analyzer',
          url: '/spas/admin/final-element-analyzer',
          roles: [
            UserGroupsEnum.SPAS_Admin,
            UserGroupsEnum.SPAS_CBMLead,
            UserGroupsEnum.SPAS_RCALead,
          ],
        },
        {
          title: 'Configuration',
          url: '/spas/admin/configuration',
          roles: [
            UserGroupsEnum.SPAS_Admin,
            UserGroupsEnum.SPAS_CBMLead,
            UserGroupsEnum.SPAS_RCALead,
          ],
          children: [
            {
              title: 'Equipment Data',
              url: '/spas/admin/configuration/equipment-data',
              roles: [
                UserGroupsEnum.SPAS_Admin,
                UserGroupsEnum.SPAS_CBMLead,
                UserGroupsEnum.SPAS_RCALead,
              ],
            },
            {
              title: 'RCA Register',
              url: '/spas/admin/configuration/rca-register',
              roles: [
                UserGroupsEnum.SPAS_Admin,
                UserGroupsEnum.SPAS_CBMLead,
                UserGroupsEnum.SPAS_RCALead,
              ],
            },
            {
              title: 'SPAS Configuration',
              url: '/spas/admin/configuration/spas-configuration',
              roles: [
                UserGroupsEnum.SPAS_Admin,
                UserGroupsEnum.SPAS_CBMLead,
                UserGroupsEnum.SPAS_RCALead,
              ],
            },
            {
              title: 'SIF Register',
              url: '/spas/admin/configuration/sif-register',
              roles: [
                UserGroupsEnum.SPAS_Admin,
                UserGroupsEnum.SPAS_CBMLead,
                UserGroupsEnum.SPAS_RCALead,
              ],
            },
          ],
        },
        {
          title: 'System Monitoring',
          url: '/spas/admin/system-monitoring',
          roles: [
            UserGroupsEnum.SPAS_Admin,
          ],
          children: [
            {
              title: 'Source Data Metrics',
              url: '/spas/admin/system-monitoring/source-data-metrics',
              roles: [
                UserGroupsEnum.SPAS_Admin,
              ],
            },
            {
              title: 'SQL Alerts',
              url: '/spas/admin/system-monitoring/sql-alerts',
              roles: [
                UserGroupsEnum.SPAS_Admin,
              ],
            },
            {
              title: 'Logs',
              url: '/spas/admin/system-monitoring/logs',
              roles: [
                UserGroupsEnum.SPAS_Admin,
              ],
            },
          ],
        },
        {
          title: 'Plant Setup',
          url: '/spas/admin/plant-setup',
          roles: [
            UserGroupsEnum.SPAS_Admin,
            UserGroupsEnum.SPAS_CBMLead
          ],
          children: [
            {
              title: 'Plant Settings',
              url: '/spas/admin/plant-setup/plant-settings',
              roles: [
                UserGroupsEnum.SPAS_Admin,
              ],
            },
            {
              title: 'System Setup',
              url: '/spas/admin/plant-setup/system-setup',
              roles: [
                UserGroupsEnum.SPAS_Admin,
              ],
            },
            {
              title: 'User Administration',
              url: '/spas/admin/plant-setup/user-administration',
              roles: [
                UserGroupsEnum.SPAS_Admin,
                UserGroupsEnum.SPAS_CBMLead
              ],
            },
            {
              title: 'SPAS License',
              url: '/spas/admin/plant-setup/spas-license',
              roles: [
                UserGroupsEnum.SPAS_Admin,
                UserGroupsEnum.SPAS_CBMLead
              ],
            },
          ],
        },
        {
          title: 'CMMS Simulator',
          url: '/spas/admin/cmms-simulator',
          roles: [
            UserGroupsEnum.SPAS_Admin,
            UserGroupsEnum.SPAS_CBMLead
          ],
          modules: [{ name: 'CMMS_SIMULATOR', display: false }],
          children: [
            {
              title: 'Programs',
              url: '/spas/admin/cmms-simulator/programs',
              roles: [
                UserGroupsEnum.SPAS_Admin,
                UserGroupsEnum.SPAS_CBMLead
              ],
            },
            {
              title: 'Work Orders',
              url: '/spas/admin/cmms-simulator/work-orders',
              roles: [
                UserGroupsEnum.SPAS_Admin,
                UserGroupsEnum.SPAS_CBMLead
              ],
            },
            {
              title: 'Shutdown Simulator',
              url: '/spas/admin/cmms-simulator/shutdown-simulator',
              roles: [
                UserGroupsEnum.SPAS_Admin,
                UserGroupsEnum.SPAS_CBMLead
              ],
            },
          ],
        },
      ],
    },
  ]
}
